export const AppConfig = {
  site_name: "ECA Glasgow",
  title: "ECA GLASGOW",
  description: "",
  locale: "en",
};
